import React from 'react'
import Header from './Header'
import Footer from './Footer'
import Container from '@material-ui/core/Container'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { rootStyles } from '../themeStyles'

const useStyles = makeStyles((theme) => ({ ...rootStyles }))

const Layout = ({ children, baseUrl, brandLogoUrl, footerContent, user, showGuestCheckout }) => {
    const classes = useStyles()

    return (
        <>
            <Header baseUrl={baseUrl} logoImageUrl={brandLogoUrl} user={user} showGuestCheckout={showGuestCheckout}/>
            <Container className={classes.root} maxWidth="lg">
                {children}
            </Container>
            <Footer content={footerContent} />
        </>
    )
}

export default Layout
